export default "__VITE_ASSET__N1erfhlw__"